<div class="container" *ngIf="contractPharmacyDetails$ | async as details">
  <div class="loading-overlay" *ngIf="details.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div class="container__form" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label
          [for]="hrsaPharmacyIdInput"
          text="Search by HRSA Pharmacy ID"
        >
        </kendo-label>
        <kendo-textbox
          #hrsaPharmacyIdInput
          class="form-field"
          formControlName="hrsaPharmacyId"
          (keydown.Enter)="getContractPharmacyDetails()"
          (keydown.Tab)="getContractPharmacyDetails()"
        >
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div class="control-wrap search-btn">
      <button
        kendoButton
        [primary]="true"
        (click)="getContractPharmacyDetails()"
      >
        <span class="k-icon k-font-icon k-i-search"></span>
        Search
      </button>
      <p *ngIf="lastSearchDate" class="search-date">
        Last searched {{ lastSearchDate | date: dateTimeFormat }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="searchSubmitted">
    <div class="container__no-data" *ngIf="!details.data">
      No HRSA pharmacy data
    </div>

    <section class="container__details" *ngIf="details.data as detailsData">
      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="HRSA Pharmacy ID">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.hrsa_pharmacy_id }}</span>
        </div>
      </div>

      <div class="detail-field span-6">
        <kendo-label class="detail-field__label" text="Name"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.pharmacy_name }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Address Line 1">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.address_line_1 }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Address Line 2">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.address_line_2 }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="City"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.city }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="State"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.state }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="Zipcode"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{
            detailsData.address_validated.zip4
              ? detailsData.address_validated.zip +
                '-' +
                detailsData.address_validated.zip4
              : detailsData.address_validated.zip
          }}</span>
        </div>
      </div>
    </section>
  </ng-container>

  <kendo-dialog-actions class="container__toolbar">
    <div class="container__buttons">
      <button kendoButton class="container__button" (click)="close()">
        Cancel
      </button>
      <button
        kendoButton
        [primary]="true"
        class="container__button"
        (click)="save()"
        [disabled]="details.pending || !details.data || !npi"
      >
        Link
      </button>
    </div>
  </kendo-dialog-actions>
</div>
